import { type TFunction } from "i18next";
import { ChevronRight, Pencil } from "lucide-react";

import { WFPButton } from "../../../../../components/ui/button";
import { ACTION_BUTTON_CLASS } from "../constants";
import { type AdministrativeAreaType } from "../../../types";

interface ActionsCellProps {
  areaType: AdministrativeAreaType;
  onOpenModal: (areaType: AdministrativeAreaType, type: "edit" | "view") => void;
  t: TFunction;
}

const ActionsCell = ({ areaType, onOpenModal, t }: ActionsCellProps) => (
  <div className="flex items-center justify-start gap-2">
    <WFPButton
      type="button"
      variant="outline"
      size="sm"
      className={ACTION_BUTTON_CLASS}
      onClick={() => onOpenModal(areaType, "view")}
    >
      {t("common.view")}
      <ChevronRight className="size-4" aria-hidden="true" />
    </WFPButton>
    <WFPButton
      type="button"
      variant="secondary"
      size="sm"
      className={ACTION_BUTTON_CLASS}
      onClick={() => onOpenModal(areaType, "edit")}
    >
      <Pencil className="size-4" aria-hidden="true" />
      {t("common.edit")}
    </WFPButton>
  </div>
);

export { ActionsCell };
